import { makeStyles } from '@material-ui/styles';
import { ArrowLeftSLine, ArrowRightSLine, CupLine, Theme, UserLine } from '@bizzabo/design-system';
import cn from 'clsx';

import useProfileAnalytics from 'people/UserProfile/hooks/useProfileAnalytics';
import { CSS_TRANSITION_DELAY, DrawerNav } from '../const';
import { useDrawerContentAtom } from '../../atoms';
import DrawerDivider from '../../Components/DrawerDivider';
import DrawerLink from '../../Components/DrawerLink';
import { BackButton } from '../../Components';
import useScheduleMeetingsEnabled from '../../../../../meetings/hooks/useScheduleMeetingsEnabled';

export const DrawerMySettings: React.FC<{ eventUniqueName: string }> = ({ eventUniqueName }) => {
    const { setDrawerContent } = useDrawerContentAtom();
    const { data: isNetworkingSettingEnabled } = useScheduleMeetingsEnabled(eventUniqueName);
    const { sendMobileProfileOpen } = useProfileAnalytics();

    const classes = useStyles();

    return (
        <nav className={classes.mySettings}>
            <div className={cn(classes.backButton, classes.menuSection)}>
                <BackButton to={DrawerNav.DEFAULT_NAVIGATION} buttonText="My Settings">
                    <ArrowLeftSLine />
                </BackButton>
            </div>

            <div className={classes.menuSection}>
                <DrawerLink
                    className={classes.link}
                    onClick={() => {
                        setDrawerContent(DrawerNav.MY_PROFILE_CONTENT);
                        sendMobileProfileOpen();
                    }}
                >
                    <UserLine className={classes.buttonIcon} /> My Profile{' '}
                    <ArrowRightSLine className={classes.buttonArrow} />
                </DrawerLink>
            </div>
            <DrawerDivider />
            {isNetworkingSettingEnabled ? (
                <>
                    <div className={classes.menuSection}>
                        <DrawerLink
                            className={classes.link}
                            onClick={() => setDrawerContent(DrawerNav.MEETINGS_CONTENT)}
                        >
                            <CupLine className={classes.buttonIcon} /> Meetings{' '}
                            <ArrowRightSLine className={classes.buttonArrow} />
                        </DrawerLink>
                    </div>
                    <DrawerDivider />
                </>
            ) : null}
        </nav>
    );
};

export const useStyles = makeStyles<Theme>(
    () => ({
        mySettings: {
            width: '100%',
            padding: '25px 0px',
            backgroundColor: 'transparent',
            transition: 'all 300ms ease-in',
            animation: `$appear ${CSS_TRANSITION_DELAY}ms ease`,
        },
        '@keyframes appear': {
            '0%': {
                opacity: 0,
            },
            '100%': {
                opacity: 1,
            },
        },
        menuSection: {
            padding: '0px 32px',
        },
        backButton: {
            marginBottom: 24,
        },
        link: {
            width: '100%',
            margin: '24px 0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-flex',
            alignItems: 'center',
        },
        buttonIcon: {
            marginRight: 12,
        },
        buttonArrow: {
            marginLeft: 'auto',
            marginRight: 20,
            width: 28,
            height: 28,
        },
    }),
    { classNamePrefix: 'drawer-my-settings' }
);
